import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const makeBrandsInactive = async (data: number[]) => {
	const response = await cmsClient.delete<unknown>(
		"/homepage/admin/app-branding/publish/",
		{ data }
	);

	return response.data;
};

const useMakeAppBrandsInactive = () => {
	const queryClient = useQueryClient();

	const onSuccess = async () => {
		toast.success(
			<CustomToast
				type="Success"
				message="App brand inactive - moved to library"
			/>,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["active-app-brand"]);
		queryClient.invalidateQueries(["app-brand-library"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(makeBrandsInactive, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useMakeAppBrandsInactive;
